import { render, staticRenderFns } from "./FieldPhoneCountry.vue?vue&type=template&id=df4fae3c&scoped=true&"
import script from "./FieldPhoneCountry.vue?vue&type=script&lang=js&"
export * from "./FieldPhoneCountry.vue?vue&type=script&lang=js&"
import style0 from "./FieldPhoneCountry.vue?vue&type=style&index=0&id=df4fae3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4fae3c",
  null
  
)

export default component.exports